import type { Components, Theme } from '@mui/material/styles'
import { varAlpha } from 'minimal-shared/utils'
import { scaleBorderRadius } from '../../utils/scale-border-radius'

// ----------------------------------------------------------------------

const MuiSkeleton: Components<Theme>['MuiSkeleton'] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { animation: 'wave', variant: 'rounded' },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: varAlpha(theme.vars.palette.grey['400Channel'], 0.12),
    }),
    rounded: ({ theme }) => ({ borderRadius: scaleBorderRadius(theme.shape.borderRadius, 2) }),
  },
}

// ----------------------------------------------------------------------

export const skeleton = { MuiSkeleton }
